import React, { memo, useState, useEffect } from 'react'
import { HeadingText, BodyText, Link, Avatar } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PP_LOGGED_OUT_URL } from '../../../../constants/constants'
import { fptiCustomImpression } from '../../../../utils'
import DATAPRIVACY_FPTI from '../../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const VerificationClosed = memo(() => {
  const [impressionDone, setImpressionDone] = useState(false)

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.VERIFICATION_CLOSED_IMPRESSION)
    }
  }, [])

  return (
    <>
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen text-center">
            <div className="flex-center">
              <Avatar
                src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg"
                className="focusedimg"
                alt="closed"
              />
            </div>

            <HeadingText size="sm" className="">
              <Message id="dsrLoggedout.verification.closed.body.description" />
            </HeadingText>

            <div className="mt1rem">
              <BodyText className="">
                <Message
                  id="dsrLoggedout.verification.closed.newrequest"
                  link={(innerMessage) => (
                    <Link href={PP_LOGGED_OUT_URL} theme="v2">
                      {innerMessage}
                    </Link>
                  )}
                />
              </BodyText>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
VerificationClosed.displayName = 'VerificationClosed'

export default VerificationClosed
